<section class="section-shedule-app">
  
    <div class="img-shedule">
      <img src="{{ imagen_banner }}" />
    </div>
    <div class="container-shedule-app">
      <div class="header-shedule-app">
        <div class="icon-header-shedule">
          <i class="bi bi-calendar2-check" style="font-size: 55px"></i>
        </div>
        <div class="text-header-shedule">
          <h3>{{ "Schedule" | translate }}</h3>
          <p>{{ "YourAppointment" | translate }}</p>
        </div>
      </div>
      <form [formGroup]="ScheduleAppointmentForm">
        <div class="content-shedule">

          <h4 
            class="label-input-custom"
            *ngIf="indexbrand === 8" 
          > 
            {{ "SelectBrand" | translate }} 
          </h4>
          <mat-form-field appearance="outline"
          *ngIf="indexbrand === 8" >
            <mat-select
              [ngModel]="BrandsSelect"
              formControlName="Brand"
              class="selectfomra"
              name="Brand"
            >
              <mat-option
                *ngFor="let Brand of Brands"
                [value]="Brand.Description"
                (click)="filterBrand(Brand)"
              >
                {{ Brand.Description }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <h4 
            class="label-input-custom"
            *ngIf="indexbrand === 7"
          > 
            {{ "Company" | translate }}
          </h4>
          <h4 
            class="label-input-custom"
            *ngIf="indexbrand !== 7" 
          > 
            {{ "selectCompany" | translate }} 
          </h4>
          <mat-form-field appearance="outline">
            <mat-select
            [disabled]="diableDerco"
              [ngModel]="companiesSelect"
              formControlName="company"
              class="selectfomra"
              name="company"
            >
              <mat-option
                *ngFor="let company of companies"
                [value]="company"
                (click)="filterCompany(company)"
              >
                {{ company.Description }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div *ngIf="isLoading">
            <div class="overlay"></div>
            <section class="dialog-loading-container">
              <div class="uploader-status">
                <mat-spinner [diameter]="50"></mat-spinner>
              </div>
              <p class="dialog__loading-text">{{"LoadingDataMessage" | translate}}</p>
            </section>
          </div> 
          
          <h4 
            class="label-input-custom"
            *ngIf="indexbrand === 7"
          > 
            {{ "City" | translate }}
          </h4>
          <h4 
            class="label-input-custom"
            *ngIf="indexbrand !== 7" 
          > 
            {{ "selectLocation" | translate }} 
          </h4>
          
          <mat-form-field appearance="outline">
            <mat-select
            [disabled]="diableDerco"
              formControlName="location"
              class="selectfomra"
              name="location"
            >
              <mat-option
                *ngFor="let location of Location"
                [value]="location.Id"
                (click)="filterLocation(location)"
              >
                {{location.Description}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div
            *ngIf="
              locationControl?.invalid &&
              (locationControl?.touched || locationControl?.dirty)
            "
          >
            <p class="error-ms" *ngIf="locationControl.errors?.['required']">
              {{ "ObligatoryField" | translate }}
            </p>
          </div>
        </div>
      </form>
      
      <div class="container-scheduling-cards">
        <h4 class="label-input-custom-blue">
          {{ "SelectYourAppointment" | translate }}
        </h4>
        <div class="content-cards">
          <button
            [disabled]="ScheduleAppointmentForm.invalid"
            class="cards-scheduling-workshop"
            [routerLink]="chooseServiceWorkshopUrl"
            [state]="{
              schedule: emptyschedule,
              brand: recievedBrandData[0],
              cityId: city,
              cityName: cityName,
              country: recievedCountryData,
              companiesSelect :companiesSelect,
              locationSelect:locationSelect,
              LanguageForCountry: recievedLanguageForCountry,
              tokenIncadea: receivedTokenIncadea,
              nameCountry : receivedNameCountry,
              BackEndCode:receivedBackEndCode,
              utmParams:utmParams
            }"
          >
            <i class="bi bi-tools"></i>
            <div class="cards-text">
              <h3>{{ "ByWorkshop" | translate }}</h3>
              <p>
                {{ "TextForWorkshopScheduleAppointments" | translate }}
              </p>
            </div>
          </button>
          <!-- [disabled]="ScheduleAppointmentForm.invalid" -->
        </div>
      </div>
    </div>
  </section>
